import React from 'react';
import NumericInput, { NumericInputProps } from '@client/components/NumericInput';

export type PercentageInputProps = NumericInputProps & {
	allowNegative?: boolean;
	'data-testid'?: string;
};

const PercentageInput = ({
	allowNegative = false,
	...props
}: PercentageInputProps) => (
	<NumericInput
		addonAfter="%"
		min={allowNegative ? undefined : 0}
		{...props}
	/>
);

export default PercentageInput;
